import { cn } from "@/lib/utils";
import mark from "@/assets/brand/mark.png";
import wordmarkOnDark from "@/assets/brand/wordmark-on-dark.png";
import wordmarkOnLight from "@/assets/brand/wordmark-on-light.png";

/**
 * The Carselona logo: the cyan wordmark with its sunflower wrench "O", and
 * "Admin" beside it.
 *
 * The artwork is the customer app's own (`new_customer_app` —
 * `assets/customer-app-images/logo.png`), so the admin panel and the app
 * customers install are the same brand. Two renders of it: "DAILY" is black
 * in the original, which disappears on a dark surface, so `wordmark-on-dark`
 * has it in white. Which one shows follows the `dark` class of whatever the
 * mark sits in — the app in dark mode, or a sidebar that is dark by design.
 *
 * Without the wordmark (the icon rail, the phone top bar) it is the wrench
 * "O" alone, which is also the favicon.
 */
export function BrandMark({
  className,
  showWordmark = true,
}: {
  className?: string;
  showWordmark?: boolean;
}) {
  if (!showWordmark) {
    return (
      <img
        src={mark}
        alt="Carselona Admin"
        width={28}
        height={28}
        className={cn("size-7 shrink-0", className)}
      />
    );
  }

  return (
    <span className={cn("flex min-w-0 items-center gap-2", className)}>
      {/* 400×75 artwork shown at 24px tall: crisp on a 2x screen. */}
      <img
        src={wordmarkOnLight}
        alt="Carselona Daily"
        width={128}
        height={24}
        className="h-6 w-auto dark:hidden"
      />
      <img
        src={wordmarkOnDark}
        alt="Carselona Daily"
        width={128}
        height={24}
        className="hidden h-6 w-auto dark:block"
      />
      <span className="rounded border border-border px-1.5 text-xs font-medium text-muted-foreground">
        Admin
      </span>
    </span>
  );
}
